var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","sm6":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.operations,"label":"Operação","item-text":"title","item-value":"business","return-object":""},model:{value:(_vm.operation),callback:function ($$v) {_vm.operation=$$v},expression:"operation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }